import {Injectable} from 'ng-metadata/core';

@Injectable()
export class BrowseResultService {
    private _query:string;
    private _browseResult: Object
    get browseResult(): Object {
        return this._browseResult;
    }

    set browseResult(value: Object) {
        this._browseResult = value;
    }

    set query(value: string) {
        this._query = value;
    }
    get query(): string {
        return this._query;
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/browse/browseResult/browseResult.service.ts